'use client';

import { FC } from 'react';
import { useFeedbacksTableController } from '@/components/feedbacks-table/use-feedbacks-table-controller';
import { FeedbacksTableView } from '@/components/feedbacks-table/FeedbacksTableView';
import type { FeedbacksTableProps } from '@/components/feedbacks-table/feedbacks-table.types';

const FeedbacksTable: FC<FeedbacksTableProps> = ({ onSortChanged, onFiltersChange, defaultFilterValues }) => {
    const controller = useFeedbacksTableController({
        onFiltersChange,
        defaultFilterValues,
    });

    return <FeedbacksTableView {...controller} onSortChanged={onSortChanged} />;
};

export default FeedbacksTable;
